// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"81":"0678c5b4","132":"c26a0511","464":"8c474d03","635":"f7514f36"}[chunkId] + ".css";
};